import { MutationCache, QueryClient } from "@tanstack/react-query"
import { toast } from "sonner"

import { ErrorCode, isProblem, messageOf } from "@/lib/problem"

/** Shared client. Mutations surface errors as toasts unless they handle them (meta.silent). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, err) => {
        if (isProblem(err) && err.status >= 400 && err.status < 500) return false
        return count < 2
      },
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      if (mutation.meta?.silent) return
      if (isProblem(err) && err.errorCode === ErrorCode.VALIDATION && err.fieldErrors.length) return
      toast.error(messageOf(err))
    },
  }),
})

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: { silent?: boolean }
  }
}
